import * as React from 'react';

import CustomerSupport140 from './CustomerSupport140';

export const customerSupport140 = () => <CustomerSupport140 />;

export default {
    title: 'Illustration/CustomerSupport140',
    component: CustomerSupport140,
    parameters: {
        notes: "`import CustomerSupport140 from 'box-ui-elements/es/illustration/CustomerSupport140';`",
    },
};
